// ============================================================
// ANSHI'S MAKEOVER — SINGLE SOURCE OF TRUTH
// Edit prices / add services / update contact info here.
// No other file needs to be changed.
// ============================================================

export const BUSINESS = {
  name: "Anshi's Makeover",
  tagline: "Makeup • Hair • Skin • Nail",
  owner: "Anshi Thakur",
  headline: "Luxury Is Not Expensive, It's Priceless",
  subheadline: "Premium Makeup, Hair, Skin & Nail Studio in Ujjain",
  address:
    "Indra Gandhi Square, Kasliwal Building, 1st Floor, Freeganj, Ujjain (M.P.)",
  phone: "7225884400",
  phoneIntl: "917225884400", // for wa.me link
  whatsappLink: "https://wa.me/message/TRONROQ32BXOD1",
  instagram:
    "https://www.instagram.com/anshi_makeover_ujjain",
  mapEmbed:
    "https://www.google.com/maps?q=Indra+Gandhi+Square+Freeganj+Ujjain&output=embed",
};

// ---------- SERVICES ----------
export const SERVICE_CATEGORIES = [
  "All",
  "Threading & Waxing",
  "Body Care",
  "Facial & Cleanup",
  "Hair Services",
  "Hair Spa",
  "Nail Services",
  "Manicure & Pedicure",
  "Pre-Bridal",
  "Makeup",
  "Academy",
];

export const SERVICES = [
  // Threading & Waxing
  { name: "Eyebrow", price: 30, category: "Threading & Waxing" },
  { name: "Upper Lips", price: 10, category: "Threading & Waxing" },
  { name: "Forehead", price: 10, category: "Threading & Waxing" },
  { name: "Full Face Threading", price: 150, category: "Threading & Waxing" },
  { name: "Brazilian Face Wax", price: 300, category: "Threading & Waxing" },
  { name: "Underarms Wax", price: 100, category: "Threading & Waxing" },
  { name: "Half Hand Wax", price: 150, category: "Threading & Waxing" },
  { name: "Full Hand Wax", price: 300, category: "Threading & Waxing" },
  { name: "Half Leg Wax", price: 300, category: "Threading & Waxing" },
  { name: "Full Leg Wax", price: 650, category: "Threading & Waxing" },
  { name: "Bikini Wax", price: 1199, category: "Threading & Waxing" },

  // Body Care
  { name: "Body Bleach", price: 999, category: "Body Care" },
  { name: "Body D-Tan", price: 1499, category: "Body Care" },
  { name: "Full Body Oil Wax", price: 2200, category: "Body Care" },
  { name: "Body Massage", price: 999, category: "Body Care" },
  { name: "Body Polishing", price: 2499, category: "Body Care" },

  // Facial & Cleanup
  { name: "Kaya Cleanup", price: 500, category: "Facial & Cleanup" },
  { name: "Kaya Facial", price: 800, category: "Facial & Cleanup" },
  { name: "Dermalogica Cleanup", price: 999, category: "Facial & Cleanup" },
  { name: "Dermalogica Facial", price: 1499, category: "Facial & Cleanup" },
  { name: "Dermalogica D-Tan", price: 399, category: "Facial & Cleanup" },
  { name: "O3+ Cleanup", price: 999, category: "Facial & Cleanup" },
  { name: "D-Tan", price: 399, category: "Facial & Cleanup" },
  { name: "O3+ Facial", price: 1499, category: "Facial & Cleanup" },
  { name: "Lotus Facial", price: 1199, category: "Facial & Cleanup" },
  { name: "Hydra Facial", price: 2499, category: "Facial & Cleanup" },
  { name: "Korean Glow Facial", price: 2999, category: "Facial & Cleanup" },

  // Hair Services
  { name: "Hair Cut", price: 199, category: "Hair Services" },
  { name: "Advanced Hair Cut", price: 299, category: "Hair Services" },
  { name: "Hair Wash", price: 199, category: "Hair Services" },
  { name: "Blow Dry", price: 199, category: "Hair Services" },
  { name: "Ironing", price: 499, category: "Hair Services" },
  { name: "Curling", price: 699, category: "Hair Services" },
  { name: "Root Touchup", price: 499, category: "Hair Services" },
  { name: "Global Hair Color", price: 2999, category: "Hair Services" },
  { name: "Keratin Treatment", price: 4999, priceSuffix: "onwards", category: "Hair Services" },
  { name: "Hair Smoothening", price: 4999, priceSuffix: "onwards", category: "Hair Services" },

  // Hair Spa
  { name: "Matrix Hair Spa", price: 799, category: "Hair Spa" },
  { name: "L'Oréal Hair Spa", price: 999, category: "Hair Spa" },
  { name: "Schwarzkopf Hair Spa", price: 1199, category: "Hair Spa" },
  { name: "Anti Hair Fall Spa", price: 1799, category: "Hair Spa" },
  { name: "Advanced Repair Spa", price: 1999, category: "Hair Spa" },

  // Nail
  { name: "Gel Polish", price: 599, category: "Nail Services" },
  { name: "Korean Extensions", price: 1199, category: "Nail Services" },
  { name: "Gel Extensions", price: 2199, category: "Nail Services" },
  { name: "Acrylic Extensions", price: 2499, category: "Nail Services" },
  { name: "Extra Nail Art", price: 50, priceSuffix: "onwards", category: "Nail Services" },
  { name: "Extension Refill", price: 999, category: "Nail Services" },

  // Mani/Pedi
  { name: "Basic Manicure", price: 499, category: "Manicure & Pedicure" },
  { name: "Basic Pedicure", price: 699, category: "Manicure & Pedicure" },
  { name: "D-Tan Manicure", price: 399, category: "Manicure & Pedicure" },
  { name: "D-Tan Pedicure", price: 399, category: "Manicure & Pedicure" },
  { name: "Premium Manicure", price: 999, category: "Manicure & Pedicure" },
  { name: "Premium Pedicure", price: 999, category: "Manicure & Pedicure" },

  // Makeup
  { name: "Natural Party Makeup", price: 1500, category: "Makeup" },
  { name: "HD Party Makeup", price: 2500, category: "Makeup" },
  { name: "Airbrush Makeup", price: 5000, category: "Makeup" },
  { name: "Basic Bridal Makeup", price: 7000, category: "Makeup" },
  { name: "HD Bridal Makeup", price: 12000, category: "Makeup" },
  { name: "Airbrush Bridal Makeup", price: 15000, category: "Makeup" },
];

// ---------- PRE-BRIDAL PACKAGES ----------
export const PRE_BRIDAL = [
  {
    name: "Basic Pre-Bridal",
    price: 7999,
    highlights: [
      "Full body wax",
      "Classic facial & cleanup",
      "Manicure & pedicure",
      "Hair spa session",
    ],
  },
  {
    name: "Gold Pre-Bridal",
    price: 14999,
    featured: true,
    highlights: [
      "Premium full body care",
      "Gold facial + D-Tan",
      "Premium mani-pedi",
      "Body polishing",
      "Advanced hair spa",
    ],
  },
  {
    name: "Luxury Pre-Bridal",
    price: 19999,
    highlights: [
      "Hydra / Korean Glow facial",
      "Full body polish & bleach",
      "Luxury mani-pedi",
      "Keratin / smoothening",
      "Personalised skin plan",
    ],
  },
];

// ---------- MEMBERSHIPS ----------
export const MEMBERSHIPS = [
  {
    tier: "Gold",
    duration: "Monthly",
    price: 1499,
    perks: [
      "2 Advanced Haircuts",
      "1 Hair Spa",
      "1 D-Tan",
      "2 Threading sessions",
      "10% off on extra services",
    ],
  },
  {
    tier: "Diamond",
    duration: "Quarterly",
    price: 4999,
    perks: [
      "4 L'Oréal Hair Spa",
      "3 Haircuts",
      "2 Cleanup + 2 Facial",
      "1 Keratin Hair Treatment",
      "Unlimited Threading",
      "10% off on extra services",
    ],
  },
  {
    tier: "Platinum",
    duration: "Yearly",
    price: 11999,
    mostPopular: true,
    perks: [
      "12 Haircuts + 6 Hair Spa",
      "6 Premium Facial + 4 D-Tan",
      "2 Keratin / Smoothening",
      "Unlimited Threading + Bleach",
      "Birthday Luxury Facial FREE",
      "Priority Booking",
      "15% off on extra services",
    ],
  },
];

// ---------- ACADEMY ----------
export const ACADEMY_COURSES = [
  {
    name: "Basic Makeup Course",
    price: 15000,
    duration: "2 Weeks",
    description:
      "Foundations of skin prep, base, eyes & lips — perfect first step into the beauty industry.",
  },
  {
    name: "Advanced Makeup Course",
    price: 35000,
    duration: "1 Month",
    description:
      "HD, airbrush, bridal looks, sculpting, contouring & professional kit handling.",
    featured: true,
  },
  {
    name: "Basic to Advanced Full Course",
    price: 50000,
    duration: "2 Months",
    description:
      "Complete A-to-Z career programme — basic + advanced + bridal styling + portfolio shoot.",
  },
];

// ---------- GALLERY ----------
export const GALLERY = [
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/th70uccj_photo_2026-05-29%2018.26.35.jpeg",
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/drlaz4e1_photo_2026-05-29%2018.26.36.jpeg",
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/9kywlwk1_photo_2026-05-29%2018.26.38.jpeg",
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/5s45225r_photo_2026-05-29%2018.26.39.jpeg",
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/asrfc6y9_photo_2026-05-29%2018.26.40.jpeg",
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/nshqyimi_photo_2026-05-29%2018.26.41.jpeg",
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/r5pr6onb_photo_2026-05-29%2018.26.43.jpeg",
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/xph81qk8_photo_2026-05-29%2018.26.44.jpeg",
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/wqdonz0d_photo_2026-05-29%2018.26.46.jpeg",
];

// ---------- CERTIFICATE / ACHIEVEMENTS ----------
export const CERTIFICATE = {
  image:
    "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/i9fpqk2h_photo_2026-05-29%2018.28.47.jpeg",
  title: "Certified by Atul Chauhan",
  subtitle: "3 Days Makeup Masterclass — Bridal Makeup Studio & Academy",
  description:
    "Anshi Thakur is a certified makeup artist who continues to upgrade her craft by training under industry-leading masters. This certification reflects her dedication to bringing world-class techniques to every client at Anshi's Makeover.",
};

// ---------- HERO / ABOUT IMAGES ----------
export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/wqdonz0d_photo_2026-05-29%2018.26.46.jpeg";

export const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_beauty-studio-anshi/artifacts/asrfc6y9_photo_2026-05-29%2018.26.40.jpeg";

// ---------- TESTIMONIALS ----------
export const TESTIMONIALS = [
  {
    name: "Riya Sharma",
    role: "Bride",
    text:
      "Anshi didi made me look like a princess on my wedding day. The makeup stayed flawless from morning to midnight. Beyond grateful!",
    rating: 5,
  },
  {
    name: "Pooja Verma",
    role: "Working Professional",
    text:
      "The Korean Glow Facial is hands down the best I've had in Ujjain. My skin literally glows for weeks. Studio is so calming & premium.",
    rating: 5,
  },
  {
    name: "Anjali Patel",
    role: "Academy Student",
    text:
      "Joined the Advanced course — Anshi ma'am teaches every detail patiently. I'm already taking clients of my own. Life-changing!",
    rating: 5,
  },
  {
    name: "Sneha Joshi",
    role: "Regular Member",
    text:
      "Platinum membership is the best investment I made for my self-care. Priority booking, free birthday facial — total queen treatment.",
    rating: 5,
  },
];
